import React from "react";
import { Box, Button, Card, CardContent, Chip, Stack, Typography } from "@mui/joy";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { useTheme } from "@mui/joy/styles";
import { Link } from "react-router-dom";

import AdminUsers from "../components/Admin/AdminUsers";

export default function AdminUsersPage() {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const heroBackground = isDark
    ? "linear-gradient(180deg, rgba(15, 23, 42, 0.96) 0%, rgba(10, 15, 26, 0.98) 100%)"
    : "radial-gradient(120% 140% at 8% 0%, rgba(255, 218, 170, 0.2) 0%, rgba(255, 218, 170, 0) 55%), radial-gradient(120% 140% at 95% 5%, rgba(165, 197, 255, 0.2) 0%, rgba(165, 197, 255, 0) 60%), linear-gradient(180deg, rgba(255, 252, 245, 1) 0%, rgba(248, 250, 255, 1) 45%, rgba(244, 246, 252, 1) 100%)";
  const heroOverlay = isDark
    ? "radial-gradient(120% 120% at 15% -10%, rgba(56, 189, 248, 0.14), transparent 60%), radial-gradient(120% 120% at 100% 0%, rgba(251, 191, 36, 0.12), transparent 55%)"
    : "radial-gradient(120% 120% at 15% -10%, rgba(255, 220, 160, 0.45), transparent 60%), radial-gradient(120% 120% at 100% 0%, rgba(129, 158, 255, 0.28), transparent 55%)";
  const heroTitle = isDark ? "rgba(248,250,252,0.92)" : "text.primary";
  const heroBody = isDark ? "rgba(226,232,240,0.78)" : "text.secondary";
  const panelWarm = isDark
    ? "linear-gradient(135deg, rgba(30, 41, 59, 0.9), rgba(15, 23, 42, 0.95))"
    : "linear-gradient(135deg, rgba(255, 237, 213, 0.9), rgba(255, 247, 231, 0.9))";
  const panelCool = isDark
    ? "linear-gradient(135deg, rgba(15, 23, 42, 0.9), rgba(30, 41, 59, 0.95))"
    : "linear-gradient(135deg, rgba(224, 243, 255, 0.8), rgba(241, 249, 255, 0.95))";

  return (
    <Box>
      <Stack spacing={3}>
        <Card
          variant="outlined"
          sx={{
            position: "relative",
            overflow: "hidden",
            borderRadius: "xl",
            borderColor: "divider",
            boxShadow: "lg",
            background: heroBackground,
          }}
        >
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              background: heroOverlay,
              opacity: 0.9,
              pointerEvents: "none",
            }}
          />
          <CardContent sx={{ position: "relative" }}>
            <Stack spacing={2}>
              <Stack direction={{ xs: "column", md: "row" }} spacing={2} alignItems={{ xs: "flex-start", md: "center" }} justifyContent="space-between">
                <Stack spacing={0.75}>
                  <Chip size="sm" variant="soft" color="neutral" sx={{ alignSelf: "flex-start", fontWeight: 600 }}>
                    Community family
                  </Chip>
                  <Typography level="h2" sx={{ fontWeight: 800, color: heroTitle }}>
                    Devotees & supporters
                  </Typography>
                  <Typography level="body-sm" sx={{ maxWidth: 680, color: heroBody }}>
                    Celebrate every soul serving ISKCON Kanpur. Search, nurture, and guide devotees in their seva journey.
                  </Typography>
                </Stack>
                <Stack direction={{ xs: "column", sm: "row" }} spacing={1}>
                  <Button startDecorator={<EditRoundedIcon />} component={Link} to="/users/bulk-edit" variant="soft" color="primary">
                    Bulk edit
                  </Button>
                  <Button startDecorator={<AddRoundedIcon />} variant="soft">
                    Invite devotee
                  </Button>
                </Stack>
              </Stack>
              <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
                <Card
                  variant="soft"
                  sx={{
                    flex: 1,
                    borderRadius: "lg",
                    background: panelWarm,
                    boxShadow: "sm",
                  }}
                >
                  <CardContent>
                    <Typography level="title-sm" sx={{ color: "text.secondary" }}>
                      Nurture journeys
                    </Typography>
                    <Typography level="title-lg" sx={{ mt: 0.5 }}>
                      Keep profiles clean
                    </Typography>
                    <Typography level="body-sm" sx={{ color: "text.secondary" }}>
                      Capture contact details, roles, and contributions with care.
                    </Typography>
                  </CardContent>
                </Card>
                <Card
                  variant="soft"
                  sx={{
                    flex: 1,
                    borderRadius: "lg",
                    background: panelCool,
                    boxShadow: "sm",
                  }}
                >
                  <CardContent>
                    <Typography level="title-sm" sx={{ color: "text.secondary" }}>
                      Invite & engage
                    </Typography>
                    <Typography level="title-lg" sx={{ mt: 0.5 }}>
                      Grow the seva family
                    </Typography>
                    <Typography level="body-sm" sx={{ color: "text.secondary" }}>
                      Add new devotees, link roles, and follow their seva progress.
                    </Typography>
                  </CardContent>
                </Card>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
        <AdminUsers />
      </Stack>
    </Box >
  );
}
